import styled from "styled-components";

export const StyledGlobalMedicalCentersFiltersButton = styled.div<any>`
  display: flex;
  padding: 8px 30px;
  gap: 12px;
  border: 1px solid #e7e7e7;
  border-radius: 5px;
  cursor: ${(props) => (props.status ? 'pointer' : 'not-allowed')};
  transition: 0.3s ease;
  align-items: center;
  font-size: 12px;
  font-weight: bold;
  white-space: nowrap;
  opacity: ${(props) => (props.status ? '100%' : '30%')};
  min-height: 24px;

  &:hover {
    background-color: ${(props) => (props.status ? '#FAFAFA' : '')};
    border: ${(props) => (props.status ? '1px solid black' : '')};
  }
`;
